export default "<v-app>\r\n  <v-main>\r\n    <AppLayout>\r\n      <router-view />\r\n    </AppLayout>\r\n  </v-main>\r\n</v-app>\r\n"